import { SidebarModule } from '@/config/permissions'
import { useModuleAccess } from '@/hooks/use-module-access'
import { Main } from '@/components/layout/main'
import { DepartmentsDataTable } from './components/data-table'
import { DepartmentsDialogs } from './components/departments-dialogs'
import { DepartmentsPrimaryButtons } from './components/departments-primary-buttons'
import DepartmentsProvider from './context/departments-context'

export default function Departments() {
  useModuleAccess(SidebarModule.DEPARTMENTS)
  return (
    <DepartmentsProvider>
      <Main>
        <div className='flex flex-wrap items-center justify-between mb-2 space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Departamentos</h2>
            <p className='text-muted-foreground'>
              Aqui você gerencia os departamentos dos seus atendimentos.
            </p>
          </div>
          <DepartmentsPrimaryButtons />
        </div>
        <div className='flex-1 px-4 py-1 -mx-4 overflow-auto lg:flex-row lg:space-x-12 lg:space-y-0'>
          <DepartmentsDataTable />
        </div>
      </Main>

      <DepartmentsDialogs />
    </DepartmentsProvider>
  )
}
